export default __webpack_public_path__ + "static/media/torso-top-front.e4de3ad5.png";